import { render, staticRenderFns } from "./DailyCuts.vue?vue&type=template&id=0b0ce157&"
import script from "./DailyCuts.vue?vue&type=script&lang=js&"
export * from "./DailyCuts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports